<div mat-dialog-title class="title">
  <h2>{{ data.textKey | locLabel }}</h2>
</div>
<div class="decision-content" mat-dialog-content>
  <app-date-input
    [formControl]="date"
    [hours]="true"
    [min]="data.minDate"
    [max]="data.maxDate"
  ></app-date-input>
  <div class="buttons">
    <button
      mat-stroked-button
      class="fliko-stroked-button-filled"
      color="primary" type="button"
      [disabled]="!date || !date.value || date.invalid"
      [mat-dialog-close]="date.value">
      {{ data.acceptKey | locCap }}
    </button>
    <button
      mat-stroked-button
      class="fliko-stroked-button"
      color="primary"
      type="button"
      [mat-dialog-close]="null"
      *ngIf="data.cancelKey"
    >
      {{ data.cancelKey | locCap }}
    </button>
  </div>
</div>
